import { v4 as uuidv4 } from 'uuid';
import { Box, Grid, Skeleton, Container, Button } from '@mui/material';
import React, { useContext, useState, useEffect } from 'react';
import { useApolloClient } from '@apollo/client';
import { useRouter } from 'next/router';
import { useTheme } from '@mui/material/styles';
import getConfig from 'next/config';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import styles from './styles';
import EirInformation from '../eir-information/EirInformation';
import EirValidateBBService from './EirValidateBBService';
import EirKeepLandlineNumberService from './EirKeepLandlineNumberService';
import RootContext from '../../../util/root.context';
import { displayCart } from '../eir-cart/cart.util';
import useLocalStorage from '../../hooks/useLocalStorage';
import EirActionModal from '../eir-action-modal/EirActionModal';
import { useToggle } from '../../hooks/useToggle';
import UANErrorModal from './UANErrorModal';
import { BROADBAND_TECHNOLOGY } from '../shared/Constants';
import { onLoadCurrentService, onGetSelectedOfferTechnology } from './ascertain.util';
import fetchInfo from '../../../util/fetchModalData';

const { publicRuntimeConfig } = getConfig();

/**
 * @name EirAscertainServiceContainer - jsx component for Ascertain Service container
 */
const EirAscertainServiceContainer = ({
  cmsData,
  getQAForBB,
  bbUANError,
  bbUANValidated,
  accountNumber,
  fixedLinePhoneNumber,
  fixedLineUAN,
  getAreaCode,
  areacodes,
  hasMultipleUANServices,
  getQAForFixedline,
  fixedLineError,
  fixedLineValidated,
  getNLE,
  NLEData,
  saveAscertain,
  showLoader,
}) => {
  const theme = useTheme();
  const localStore = useLocalStorage();
  const router = useRouter();
  const graphql = useApolloClient();

  const [cartOfferId, setCartOfferId] = useState();
  const [bbServiceCheckMark, setBBServiceCheckMark] = useState(false);
  const [isNBIJourney, setIsNBIJourney] = useState(false);
  const [isFTTHJourney, setFTTHJourney] = useState(false);
  const [ascertainloader, setAscertainloader] = useState(true);
  const [enableNBISubmit, setEnableNBISubmit] = useState(false);
  const [fixedLineCheckMark, setFixedLineCheckMark] = useState(false);
  const [isPrequalChecking, setIsPrequalChecking] = useState(false);
  const [bbQAResult, setbbQAResult] = useState();
  const [PSTNlandline, setPSTNLandline] = useState(false);
  const [mobileCheckModal, setMobileCheckModal] = useState(false);
  const [bbAccountFound, setBBAccountFound] = useState(false);
  const errorUANModal = useToggle(false);
  const [fixedlineUan, setfixedlineUan] = useState('');
  const [landlineno, setLandlineno] = useState('');
  const [bbUANPhNo, setBBUANPhNo] = useState('');
  const [keepNumberStateInError, setKeepNumberStateInError] = useState(false);
  const [uanDetails, setUanDetails] = useState({ provider: '', number: '' });
  const { state: rootState, dispatch } = useContext(RootContext);
  const [cmsCollectionData, setCmsCollectionData] = useState({});
  const [load, setLoad] = useState(true);

  const getCmsData = async () => {
    try {
      const data = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: 'BB-add_eirMobile',
      });
      if (Object?.keys(data).length !== 0) {
        setLoad(false);
        setCmsCollectionData(data);
      }
    } catch (error) {
      console.error('error', error);
    }
  };
  useEffect(() => {
    getCmsData();
  }, []);

  const nextStep = async () => {
    const newFixedLineValidated = keepNumberStateInError || fixedLineValidated;
    const ascertainRequest = {
      // broadbandUan: accountNumber,
      hasActiveBroadband: bbUANValidated,
      keepMobileNumber: isNBIJourney ? false : newFixedLineValidated || PSTNlandline,
      broadbandServiceDetails: {
        accountNumber,
        phoneNumber: bbUANPhNo,
      },
      fixedServiceDetails: {
        accountNumber: fixedLineUAN ? JSON.stringify(fixedLineUAN) : fixedlineUan,
        phoneNumber: fixedLinePhoneNumber || landlineno,
      },
      // mobileNbr: fixedLinePhoneNumber || landlineno,
      // mobileUan: fixedLineUAN ? JSON.stringify(fixedLineUAN) : fixedlineUan,
    };
    const ascertainData = await saveAscertain(cartOfferId, ascertainRequest);
    if (ascertainData) {
      setMobileCheckModal(true);
    } else {
      errorUANModal.enable();
    }
  };
  const handleYes = () => {
    router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile`);
  };
  const handleNo = () => {
    setMobileCheckModal(true);
    router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/redirectSummary`);
  };

  const enableNext = enable => {
    displayCart({
      dispatch,
      localStorage: localStore,
      graphql,
      cart: rootState.cart,
      nextMethod: nextStep,
      disablenNextButton: !enable,
    });
    dispatch({
      type: 'SET_NEXT_BUTTON_METHOD',
      payload: {
        show: false,
        enable,
        action: nextStep,
      },
    });
    dispatch({
      type: 'SET_CHECKOUT_BUTTON',
      payload: {
        show: false,
        enable: false,
      },
    });
  };

  const onload = async () => {
    const { cart, error } = await onLoadCurrentService({ graphql, localStorage: localStore });
    if (error) {
      // TODO notification for api fail
      console.error('Something went wrong !', error);
      return error;
    }
    if (cart) dispatch({ type: 'SET_CART', payload: cart });
  };

  useEffect(() => {
    // checkforNBI method is to derive NBI Journey and to hide active bb step
    const checkforNBI = async () => {
      const cartoffer = await onGetSelectedOfferTechnology({ graphql });
      if (cartoffer.broadbandTechnolgy === BROADBAND_TECHNOLOGY.NBI) {
        console.log('NBIJourney');
        setBBServiceCheckMark(true);
        setIsNBIJourney(true);
        setAscertainloader(false);
        setCartOfferId(cartoffer?.offerId);
      } else {
        setFTTHJourney(true);
        setAscertainloader(false);
      }
    };
    checkforNBI();
    onload();
    enableNext(false);
    getAreaCode();
  }, []);

  useEffect(() => {
    if (bbServiceCheckMark && (fixedLineCheckMark || fixedLineValidated) && !isPrequalChecking) {
      nextStep();
    }
  }, [bbUANValidated, bbServiceCheckMark, fixedLineCheckMark, fixedLineValidated]);

  // dispatch({ type: 'SET_CART' });

  return (
    <Container maxWidth='lg'>
      <Grid container sx={styles(theme).ascertainContainer}>
        {ascertainloader ? (
          <LoadingSkeleton />
        ) : (
          <>
            <Box sx={{ m: '0 auto 32px auto', width: '100%' }}>
              <EirInformation
                title={cmsData?.attributes?.EirInformation_Ascertain?.title}
                description={cmsData?.attributes?.EirInformation_Ascertain?.description}
                textAlign={cmsData?.attributes?.EirInformation_Ascertain?.textAlign}
                useH1={cmsData?.attributes?.EirInformation_Ascertain?.useH1}
                style={{
                  title: { color: theme.palette.primary.textColor3 },
                  discription: { color: theme.palette.primary.textColor3 },
                }}
              />
            </Box>
            {isFTTHJourney && (
              <>
                <Grid item xs={12} sx={styles(theme).validateBBServiceContainer}>
                  <EirValidateBBService
                    getQAForBB={getQAForBB}
                    bbUANValidated={bbUANValidated}
                    bbServiceCheckMark={bbServiceCheckMark}
                    setBBServiceCheckMark={setBBServiceCheckMark}
                    setIsPrequalChecking={setIsPrequalChecking}
                    bbUANError={bbUANError}
                    errorUANModal={errorUANModal}
                    hasMultipleUANServices={hasMultipleUANServices}
                    getNLE={getNLE}
                    NLEData={NLEData}
                    setCartOfferId={setCartOfferId}
                    bbAccountFound={bbAccountFound}
                    setBBAccountFound={setBBAccountFound}
                    showLoader={showLoader}
                    setBBUANPhNo={setBBUANPhNo}
                    setbbQAResult={setbbQAResult}
                    cmsData={cmsData}
                    setUanDetails={setUanDetails}
                    uanDetails={uanDetails}
                  />
                </Grid>
                <Grid item xs={12} sx={styles(theme).validateBBServiceContainer}>
                  <EirKeepLandlineNumberService
                    enableNext={enableNext}
                    getQAForFixedline={getQAForFixedline}
                    areacodes={areacodes}
                    setFixedLineCheckMark={setFixedLineCheckMark}
                    bbServiceCheckMark={bbServiceCheckMark}
                    bbAccountFound={bbAccountFound}
                    errorUANModal={errorUANModal}
                    fixedLineValidated={fixedLineValidated}
                    fixedLineError={fixedLineError}
                    setfixedlineUan={setfixedlineUan}
                    setLandlineno={setLandlineno}
                    bbQAResult={bbQAResult}
                    setPSTNLandline={setPSTNLandline}
                    setKeepNumberStateInError={setKeepNumberStateInError}
                    uanDetails={uanDetails}
                  />
                </Grid>
              </>
            )}
            {isNBIJourney && (
              <Grid item xs={12} sx={styles(theme).validateBBServiceContainer}>
                <EirKeepLandlineNumberService
                  enableNext={enableNext}
                  getQAForFixedline={getQAForFixedline}
                  areacodes={areacodes}
                  setFixedLineCheckMark={setFixedLineCheckMark}
                  bbServiceCheckMark={bbServiceCheckMark}
                  bbAccountFound={bbAccountFound}
                  errorUANModal={errorUANModal}
                  fixedLineValidated={fixedLineValidated}
                  fixedLineError={fixedLineError}
                  setfixedlineUan={setfixedlineUan}
                  setLandlineno={setLandlineno}
                  bbQAResult={bbQAResult}
                  setPSTNLandline={setPSTNLandline}
                  setKeepNumberStateInError={setKeepNumberStateInError}
                  uanDetails={uanDetails}
                  setEnableNBISubmit={setEnableNBISubmit}
                  isNBIJourney={isNBIJourney}
                />
                {isNBIJourney && (
                  <Grid
                    container
                    direction='row'
                    justifyContent='center'
                    sx={{ marginBottom: '50px' }}
                  >
                    <Button
                      variant='buttonMedium'
                      onClick={nextStep}
                      sx={
                        enableNBISubmit
                          ? styles(theme).enableSubmitCTA
                          : styles(theme).disableSubmitCTA
                      }
                      aria-label='Proceed to review your order'
                    >
                      Next
                      <ArrowForwardIcon sx={{ ml: 1 }} />
                    </Button>
                  </Grid>
                )}
              </Grid>
            )}
          </>
        )}
        {/* <Grid item xs={12} sx={styles(theme).submitCTAContainer}>
        <Button
          sx={[
            styles(theme).submitCTA,
            (bbUANValidated || bbServiceCheckMark) && (fixedLineCheckMark || fixedLineValidated)
              ? ''
              : styles(theme).disablecta,
          ]}
          onClick={() => nextStep()}
        >
          Next
          <ArrowForwardIcon sx={{ ml: 1 }} />
        </Button>
      </Grid> */}

        <EirActionModal
          id={cmsCollectionData?.attributes?.modalID}
          open={mobileCheckModal}
          handleClose={mobileCheckModal.disable}
          desktopImageSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI_SERVER}${
            cmsCollectionData?.attributes?.desktopImage?.data?.attributes?.url || ''
          }`}
          mobileImageSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI_SERVER}${
            cmsCollectionData?.attributes?.mobileImage?.data?.attributes?.url || ''
          }`}
          desktopImageAlt={
            cmsCollectionData?.attributes?.desktopImage?.data?.attributes?.alternativeText
          }
          mobileImageAlt={
            cmsCollectionData?.attributes?.mobileImage?.data?.attributes?.alternativeText
          }
          desktopCurveImg={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
            cmsCollectionData?.attributes?.desktopCurveImg?.data?.attributes?.url || ''
          }`}
          mobileCurverImg={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
            cmsCollectionData?.attributes?.mobileCurverImg?.data?.attributes?.url || ''
          }`}
          desktopCurveImgAlt='desktopCurve'
          mobileCurverImgAlt='mobileCurve'
          title={cmsCollectionData?.attributes?.title}
          description={`${
            cmsCollectionData?.attributes?.firstHalfDescription
              ? cmsCollectionData?.attributes?.firstHalfDescription
              : ''
          }
          ${
            cmsCollectionData?.attributes?.secondHalfDescription
              ? cmsCollectionData?.attributes?.secondHalfDescription
              : ''
          }
          `}
          cta={[
            {
              // text: 'Shop Mobile',
              text: cmsCollectionData?.attributes?.cta[0]?.name
                ? cmsCollectionData?.attributes?.cta[0]?.name
                : 'Shop Mobile',
              type: 'contained',
              action: () => handleYes(),
              ariaLabel: cmsCollectionData?.attributes?.cta[0]?.ariaLabel
                ? cmsCollectionData?.attributes?.cta[0]?.ariaLabel
                : '',
            },
            {
              // text: 'Go to checkout',
              text: cmsCollectionData?.attributes?.cta[1]?.name
                ? cmsCollectionData?.attributes?.cta[1]?.name
                : 'Go to checkout',
              type: 'contained',
              action: () => handleNo(),
              ariaLabel: cmsCollectionData?.attributes?.cta[1]?.ariaLabel
                ? cmsCollectionData?.attributes?.cta[1]?.ariaLabel
                : '',
            },
          ]}
          disableCloseOnBackdropClick
          disableCloseOnEscapeKeyDown
          disablecta={false}
          load={load}
        />
        {errorUANModal.value && <UANErrorModal errorUANModal={errorUANModal} />}
      </Grid>
    </Container>
  );
};
const LoadingSkeleton = () =>
  Array(3)
    .fill()
    .map(() => (
      <Grid item xs={12} sx={{}} key={uuidv4()}>
        <Skeleton />
      </Grid>
    ));
export default EirAscertainServiceContainer;
